/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';

export const getReportList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GROUP_REPORTLIST, data).then((res: IListResponse<IOutput>) => {
        return res.data;
    });
};
